module.exports = __webpack_public_path__ + "static/media/witness_02.4eb2f80e.svg";